import { useState } from 'react';
import axios from 'axios';
import { ArrowRight, Loader2, Check } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup({ source = 'unknown', compact = false }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || status === 'loading') return;
    setStatus('loading');
    setError('');
    try {
      await axios.post(`${API}/leads/newsletter`, { email: email.trim(), source }, { timeout: 20000 });
      trackEvent('newsletter_signup', { event_category: 'lead', source });
      setStatus('done');
    } catch (err) {
      setStatus('error');
      setError(err?.response?.data?.detail?.toString() || "Couldn't subscribe. Try again.");
    }
  };

  if (status === 'done') {
    return (
      <div className={`flex items-center gap-3 ${compact ? 'text-sm' : 'text-base'} text-white`}
        data-testid="newsletter-success">
        <span className="w-8 h-8 rounded-full bg-emerald-500/15 border border-emerald-500/50 flex items-center justify-center">
          <Check className="w-4 h-4 text-emerald-400" />
        </span>
        <div>
          <p className="text-white font-medium">You&apos;re on the list.</p>
          <p className="text-white/50 text-[11px] tracking-[0.2em] mt-0.5">FIRST DROP · THURSDAY · 8AM</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="w-full" data-testid="newsletter-form">
      <div className="flex items-stretch border border-white/25 focus-within:border-white/60 transition-colors bg-black/40 backdrop-blur">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@brand.com"
          required
          disabled={status === 'loading'}
          className={`flex-1 bg-transparent px-4 ${compact ? 'py-3 text-sm' : 'py-4 text-sm md:text-base'} text-white placeholder:text-white/35 focus:outline-none`}
          data-testid="newsletter-email"
        />
        <button
          type="submit"
          disabled={status === 'loading' || !email.trim()}
          className="group inline-flex items-center gap-2 px-5 bg-[#FF3D2E] hover:bg-[#ff5446] disabled:opacity-40 text-white text-[11px] tracking-[0.25em] transition-colors"
          data-testid="newsletter-submit"
        >
          {status === 'loading' ? (
            <><Loader2 className="w-4 h-4 animate-spin" /> SENDING</>
          ) : (
            <>SUBSCRIBE <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" /></>
          )}
        </button>
      </div>
      {error && <p className="mt-2 text-[12px] text-[#FF3D2E]">{error}</p>}
    </form>
  );
}
